<template>
    <div>
        <Breadcrumbs main="Admin" submain="Location" title="Shelter" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Shelter</h7>
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="shelter_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(name)="row">
                                            <div v-if="row.item.name">
                                                <p>{{ row.item.name }}</p>
                                                <b-badge style="cursor: pointer;" @click="gotoURL(row.item.id)">View Dashboard</b-badge>
                                            </div>
                                        </template>

                                        <template #cell(union)="row">
                                            <div v-if="row.item.union">
                                                <p>{{ row.item.union.union_name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(capacity)="row">
                                            <div v-if="row.item.capacity">
                                                <p>{{ row.item.capacity }}</p>
                                            </div>
                                        </template>

                                        <template #cell(shelter_type)="row">
                                            <div v-if="row.item.shelter_type">
                                                <p v-if="row.item.shelter_type == 'mpds'">MPDS</p>
                                                <p v-if="row.item.shelter_type == 'para_center'">Para Center</p>
                                            </div>
                                        </template>

                                        <template #cell(image)="row">
                                            <div v-if="row.item.image">
                                                <img style="height: 70px;" :src="host + row.item.image" alt="">
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteShelter(data.item.id)" title="Delete"></feather>
                                                </div>
    
                                                <div @click="editShelter(data.item)">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Shelter Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Shelter" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter shelter name" v-model="shelter.name">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Upazila</label>
                            <select class="form-control digits" @change="getUnionsByUpazila" v-model="shelter_upozila">
                                <option selected disabled>Select a upazila</option>
                                <option v-for="(upo, index) in upozilas" :key="index" :value="upo.id">{{ upo.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Union</label>
                            <select class="form-control digits" v-model="shelter.union">
                                <option selected disabled>Select a union</option>
                                <option v-for="(uni, index) in unions" :key="index" :value="uni.id">{{ uni.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Capacity</label>
                            <input class="form-control" type="text" placeholder="Enter shelter capacity" v-model="shelter.capacity">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Shelter Type</label>
                            <select class="form-control digits" v-model="shelter.shelter_type">
                                <option selected disabled>Select a type</option>
                                <option v-for="(type, index) in types" :key="index" :value="type.value">{{ type.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Image</label>
                            <div class="flex items-center">
                                <img v-if="show_image" style="width: 120px; height: 80px;" :src="show_image">
                                <input :class="shelter.image ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="uploadFile">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Shelter Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Shelter" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter shelter name" v-model="edit_shelter.name">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Upazila</label>
                            <select class="form-control digits" @change="getUnionsByUpazilaEdit" v-model="edit_shelter_upozila">
                                <option selected disabled>Select a upazila</option>
                                <option v-for="(upo, index) in upozilas" :key="index" :value="upo.id">{{ upo.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Union</label>
                            <select class="form-control digits" v-model="edit_shelter.union">
                                <option selected disabled>Select a union</option>
                                <option v-for="(uni, index) in edit_unions" :key="index" :value="uni.id">{{ uni.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Capacity</label>
                            <input class="form-control" type="text" placeholder="Enter shelter capacity" v-model="edit_shelter.capacity">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Shelter Type</label>
                            <select class="form-control digits" v-model="edit_shelter.shelter_type">
                                <option selected disabled>Select a type</option>
                                <option v-for="(type, index) in types" :key="index" :value="type.value">{{ type.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Image</label>
                            <div class="flex items-center">
                                <img v-if="show_edit_image" style="width: 120px; height: 80px;" :src="show_edit_image">
                                <input :class="edit_shelter.image ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadEditFile">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Shelter Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this shelter?</div>
        </b-modal>
    </div>
    </template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            loader
        },
    
        data() {
            return {
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: 'Shelter',
                        sortable: true
                    },
                    {
                        key: 'union',
                        label: 'Union',
                        sortable: true
                    },
                    {
                        key: 'capacity',
                        label: 'Capacity',
                        sortable: true
                    },
                    {
                        key: 'shelter_type',
                        label: 'Shelter Type',
                        sortable: true
                    },
                    {
                        key: 'image',
                        label: 'Image',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
                shelter: {
                    name: '',
                    union: '',
                    capacity: '',
                    shelter_type: '',
                    image: null
                },
    
                edit_shelter: {
                    id: '',
                    name: '',
                    union: '',
                    capacity: '',
                    shelter_type: '',
                    image: null
                },

                types: [
                    {
                        value: 'mpds',
                        name: 'MPDS'
                    },
                    {
                        value: 'para_center',
                        name: 'Para Center'
                    }
                ],
                unions: [],    
                edit_unions: [],    
                show_image: null,
                show_edit_image: null,
                shelter_upozila: null,
                edit_shelter_upozila: null,
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                shelter_list: state => state.shelter.shelter,
                upozilas: state => state.upazila.upazila,
                union: state => state.union.union,
                loading: state => state.shelter.shelterLoading,
                error: state => state.shelter.shelterError
            }),
    
            sortOptions() {
                // Create an options list from our fields
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },

        watch: {
            union(oldValue, newValue) {
                this.unions = this.union
                this.edit_unions = this.union
            }
        },
    
        mounted() {
            this.$store.dispatch("union/fetchUnion")
            this.$store.dispatch("upazila/fetchUpazila")
            this.$store.dispatch("shelter/fetchShelter").then(() => {
                this.items = this.shelter_list
                this.totalRows = this.shelter_list.length;
            });
        },
    
        methods: {
            gotoURL(id){
                this.$router.push(
                    {
                        path: '/dashboard/shelter',
                        query: {
                            only_shelter: id
                        }
                    }
                )
            },
            uploadFile(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.show_image = e.target.result
                    this.shelter.image = e.target.result;
                };
            },

            uploadEditFile(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.show_edit_image = e.target.result
                    this.edit_shelter.image = e.target.result;
                };
            },

            getUnionsByUpazila() {
                this.$store.dispatch("union/getUnionsByUpazila", this.shelter_upozila).then(() => {
                    this.unions = this.union
                });
            },

            getUnionsByUpazilaEdit() {
                this.$store.dispatch("union/getUnionsByUpazila", this.edit_shelter_upozila).then(() => {
                    this.edit_unions = this.union
                });
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.shelter.name = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("shelter/addShelter", {
                    shelter: this.shelter
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.shelter.name = null
                        this.shelter.upozila = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editShelter(detail) {
                this.edit_shelter.id = detail.id ? detail.id : null
                this.edit_shelter.name = detail.name ? detail.name : null
                this.edit_shelter_upozila = detail.upozila ? detail.upozila.upozila_id : null
                this.edit_shelter.union = detail.union ? detail.union.union_id : null
                this.edit_shelter.capacity = detail.capacity ? detail.capacity : null
                this.edit_shelter.shelter_type = detail.shelter_type ? detail.shelter_type : null
                this.show_edit_image = detail.image ? this.host + detail.image : null
            },
    
            resetEditModal() {
                this.edit_shelter.name = null
                this.edit_shelter.upozila = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.$store.dispatch("shelter/updateShelter", {
                    id: this.edit_shelter.id,
                    shelter: this.edit_shelter
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.edit_shelter.name = null
                        this.edit_shelter.upozila = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteShelter(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("shelter/deleteShelter", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
    </script>
    